module.exports = __webpack_public_path__ + "img/20250225-01-02.62117b9c.png";